import React from 'react';
import _ from 'lodash';
import styled, { ThemeProvider, withTheme } from 'styled-components';

const Row = styled.div`
  display: flex;
  padding: 10px;
  margin-bottom: 2px;
  background: ${props => props.theme.fav.rowBg};
  &:last-child {
    margin-bottom: 0;
  }
  color: #fff;
`;

const Left = styled.div`
  flex: 1;
  padding: 3px 0 3px 5px;
`;
const Right = styled.div`
  flex: 1;
  padding: 3px 5px 3px 0;
  text-align: right;
`;

const FavMarketRow = ({ theme, exchange, watchList, market: { symbol }, selectMarket }) => {
  const watch = { exchange: exchange.id, market: symbol };
  const hasWatch = _.some(watchList, watch);
  return (
    <ThemeProvider theme={theme}>
      <Row>
        <Left>
          <div>{symbol}</div>
        </Left>
        <Right>
          <div>
            <input type="checkbox" id={symbol} name={symbol} checked={hasWatch} onChange={selectMarket} />
          </div>
        </Right>
      </Row>
    </ThemeProvider>
  );
};

export default withTheme(FavMarketRow);



// WEBPACK FOOTER //
// ./src/components/FavMarketRow.js